import { CalendarGridItemVariant } from '../../../../constants/calendarGrid'
import {
  getCalendarGridPopoverSecondaryLabel,
  getCalendarGridPopoverTitle,
} from '../../CalendarGrid.utils'

function getIsCalendarGridItemMuted(item) {
  return item.variant === CalendarGridItemVariant.muted
}

export function getCalendarGridCompactRowLabel(item) {
  return item.isSecondaryLabelPinned
    ? getCalendarGridPopoverSecondaryLabel(item)
    : getCalendarGridPopoverTitle(item)
}

export function getIsCalendarGridItemStatusInDayList(item) {
  return item.isStatusPinned || getIsCalendarGridItemMuted(item)
}
